<template>
  <v-container grid-list-sm text-xs-left>
    <v-layout
        row
        pa-2
        align-end
        justify-space-between
    >
      <v-flex xs12 md4 pb0 mb0 >
                <span
                      class="headline"
                >
                    News
                </span>

      </v-flex>

      <v-flex v-if="!this.published && !this.toApprove" xs6 md4>
        <v-layout justify-end>
          <v-btn round
                 depressed
                 color="success"
                 @click="navigate('newNews',true)"
          >
            Create New
            <v-icon right dark>
              add
            </v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap>

      <v-flex v-for="n in news"
              :key="n._id"
              xs12 sm6 md6 lg4 xl4
              pa-2
      >
        <v-card>
          <v-img
              :lazy-src="require('@/assets/img/innovation/loadingBlueGreen.gif')"
              :src="n.image"
              aspect-ratio="2.75"
              height="200px"
          >
          </v-img>

          <v-card-title primary-title>
            <v-flex xs12 class="headline block-ellipsis-title">{{n.title}}</v-flex>
            <v-flex xs12 class="block-ellipsis-description" v-html="n.content"></v-flex>
          </v-card-title>

          <v-card-actions>
            <v-btn v-if="(published && (userInfo.role === 'APPROVER_INNOVATION')) || !published"
                slot="activator"
                color="blue"
                flat
                dark
                class="elevation-0"
                @click="navigate(n._id,false)"
            >
              Edit
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn v-if="(published && (userInfo.role === 'APPROVER_INNOVATION')) || !published"
                small
                round
                icon
                color="red"
                class="white--text"
                @click="openDeleteNewsDialog(n)"
            >
              <v-icon small dark>
                close
              </v-icon>
            </v-btn>

            <v-btn icon @click="n.selected  =! n.selected">
              <v-icon>{{ n.selected ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
            </v-btn>
          </v-card-actions>

          <v-card-text v-show=n.selected>
            <v-flex xs12><span class="font-weight-bold">Author: </span> {{n.author}} </v-flex>
            <v-flex xs12 v-if="n.published"><span class="font-weight-bold">Publication Date: </span> {{n.publicationDate}} </v-flex>
            <v-flex xs12 v-if="(n.published || n.toApprove) && (userInfo.role==='APPROVER_INNOVATION')"><span class="font-weight-bold">Creation Date: </span> {{n.creationDate}} </v-flex>
          </v-card-text>

        </v-card>
      </v-flex>

      <!-- TreeView for Delete News -->
      <v-dialog
          v-model="deleteNewsDialog"
          max-width="650"
      >
        <v-card>
          <v-card-title class="headline">Deleting "{{ newsToDelete.title}}" </v-card-title>
          <v-card-text>
            Are you sure?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                flat="flat"
                @click="closeDeleteNewsDialog()"
            >
              Cancel
            </v-btn>
            <v-btn
                color="red"
                flat="flat"
                @click="deleteNews()"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
import RouterService from "@/helpers/RouterService";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import {mapGetters} from "vuex";

export default {
  name: "NewsHomePage",
  props: {
    published: Boolean,
    toApprove: Boolean,
  },
  computed: {
    ...mapGetters("UserState", {
          userInfo: "getUserInfo",
        }
    ),
  },
  data() {
    return {
      news: [],
      selectedNews: {},
      deleteNewsDialog: false,
      newsToDelete: {},
    };
  },
  created() {
    this.getNews();
    console.log("ROLE: ",this.userInfo.role);
  },
  methods: {
    getRequireImg(path){
      console.log('require   : ----- '+path);
      return require(path)
    },
    navigate(id, newFlag) {
      console.log("newsHomePage navigate: ",newFlag);
      let path = {
        name: "NewsDetails",
        params: {
          _id: id,
          newFlagProp: newFlag,
        },
      };
      RouterService.goTo(path);
    },
    openDeleteNewsDialog(news) {
      this.newsToDelete = news;
      this.deleteNewsDialog = true;
    },
    closeDeleteNewsDialog() {
      this.selectedNews = {};
      this.deleteNewsDialog = false;
    },
    getNews() {
      let url = "";
      if(!this.published && !this.toApprove){
        url = UrlsService.getNewsNotPubNotToApp;
      } else if(this.published && !this.toApprove){
        url = UrlsService.getNewsPubNotToApp;
      } else if(!this.published && this.toApprove) {
        url = UrlsService.getNewsNotPubToApp;
      }
      let requestUrl = {
        url: url,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          integrationInteractionRequest: {

          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List News",
        loading: "Waiting for list of news...",
        error: "Cannot get news...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.news = [];
            let responseNews = responseSuccess.response.news;
            for (let i = 0; i < responseNews.length; i++) {
              responseNews[i]['selected'] = false
              this.news.push(responseNews[i])
            }
          });
    },
    deleteNews(){
      this.deleteNewsDialog = false;

      let requestUrl = {
        url: UrlsService.newsOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "DELETE",
          newsRequest: {
            news: {
              _id: this.newsToDelete._id
            }
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Delete News",
        loading: "Waiting for deletion of news...",
        error: "Cannot delete news...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.getNews()
          });
    },
  },
}
</script>

<style scoped>


/*::v-deep p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}*/

/*.cardText {
  max-width: 400px;
}*/

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.block-ellipsis-title {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 35px;
  margin: 0 auto 0 0;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden; /* auto (for vertical scrolling) or hidden */
}

.block-ellipsis-description {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 63px;
  margin: 0 auto 0 0;
  font-size: 14px;
  line-height: 1.5;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden; /* auto (for vertical scrolling) or hidden */
}

.my-span {
  background-color: white;
  opacity: 0.5;
  color: black;
  font-weight: bold;
  margin-right: 5%;
  margin-top: 2.5%;
  float: right;
}


</style>